<div class="toolbar">
  <span>
    <button matButton="text" (click)="close()" [disabled]="isBusy">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <span>Back To Product</span>
      </span>
    </button>
  </span>
</div>
<div class="priceDetail">
  <div class="leftColumn">
    <table class="pricesTable reportTable">
      <thead>
      <tr>
        <td class="tableCell headerCell">Price List</td>
        <td class="tableCell headerCell">Begin</td>
        <td class="tableCell headerCell">End</td>
        <td class="tableCell headerCell">Price</td>
      </tr>
      </thead>
      @if (productHasPrices()) {
        @for (price of product().priceLists; track price; let rowIndex = $index) {
          <tr [class.selectedRow]="rowIndex === selectedPriceRow" class="selectableRow"
              (click)="selectRow(rowIndex, price)">
            <td class="tableCell">{{ price.key.priceListId }}</td>
            <td class="tableCell">{{ price.key.beginEffectiveDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell">{{ price.endEffectiveDate | date: 'MM/dd/yyyy':'UTC' }}</td>
            <td class="tableCell rightAligned">{{ price.unitPrice | currency: 'USD' }}</td>
          </tr>
        }
      }
      @if (!productHasPrices()) {
        <tr>
          <td class="tableCell" colspan="4">No prices found</td>
        </tr>
      }
    </table>
  </div>
  @if (selectedPrice) {
    <div class="rightColumn">
      <table class="inputLayout">
        <tr>
          <td class="leftInputColumn">
            <span>Price List:</span>
          </td>
          <td class="rightInputColumn">
            <span class="display-value">{{ selectedPrice.key.priceListId }}</span>
          </td>
        </tr>
        <tr>
          <td class="leftInputColumn">
            <span>Begin Effective:</span>
          </td>
          <td class="rightInputColumn">
            <span class="display-value">{{ selectedPrice.key.beginEffectiveDate | date: 'MM/dd/yyyy': 'UTC' }}</span>
          </td>
        </tr>
        <tr>
          <td class="leftInputColumn">
            <span>End Effective:</span>
          </td>
          <td class="rightInputColumn">
            <span class="display-value">{{ selectedPrice.endEffectiveDate | date: 'MM/dd/yyyy': 'UTC' }}</span>
          </td>
        </tr>
        <tr>
          <td class="leftInputColumn">
            <span>Price:</span>
          </td>
          <td class="rightInputColumn">
            <span class="display-value">{{ selectedPrice.unitPrice | currency: 'USD' }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="centered-cell">
            <span>Created: {{ selectedPrice.createUser }} - {{ selectedPrice.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="centered-cell">
            <span>Updated: {{ selectedPrice.updateUser }} - {{ selectedPrice.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</span>
          </td>
        </tr>
      </table>
      @if (isBusy) {
        <span class="busyIndicator">
          <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
          <span class="busyLabel">Please Wait...</span>
        </span>
      }
      <div class="errors">
        @if (errorText) {
          <span class="errorMessage">{{ errorText }}</span>
        }
      </div>
    </div>
  }
</div>
